// extracted by mini-css-extract-plugin
export var address = "Address-module--address--279d2";
export var bounce = "Address-module--bounce--087a3";
export var dotMoveLeft = "Address-module--dot-move-left--f33d9";
export var dotMoveRight = "Address-module--dot-move-right--5d6a5";
export var gradient = "Address-module--gradient--4c603";
export var separatorWidth = "Address-module--separator-width--24b37";